<div class="notification-modal" *ngIf="isOpen()">
  <div class="notification-modal__overlay" (click)="closeModal()"></div>
  <div class="notification-modal__content flex column gap-5">
    <h2 class="notification-modal__title" [innerHTML]="title()"></h2>
    <p class="notification-modal__message" [innerHTML]="message()"></p>

    @if(!isLoading()){
      <div class="notification-modal__actions flex" [ngClass]="justOkBtn() ? 'justify-end' : 'justify-space-between'">
        <ng-container *ngIf="justOkBtn()">
          <button class="notification-modal__button notification-modal__button--confirm"
            (click)="confirmAction()">Aceptar</button>
        </ng-container>
        <ng-container *ngIf="!justOkBtn()">
          <button class="notification-modal__button notification-modal__button--cancel"
            (click)="closeModal()">Cancelar</button>
          <button class="notification-modal__button notification-modal__button--confirm"
            (click)="confirmAction()">Aceptar</button>
        </ng-container>
      </div>
    }

  </div>
</div>